/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/** 用于获取伽利略ab实验结果 */
import { AbTestArgs } from '@/api/user/types';
import { appEnv } from '@/components/adv-components';
import store from '@/store';
import GalileoAb from '@hb/ab-sdk';
import { ubtSendError } from '@/shared/utils/ubt';
import { appVersion } from '../utils/bootstrap';
import isPrerendering from '../utils/isPrerendering';

// const shouldSendGalileoAb = GalileoAb && !IS_PRERENDERING;

const bindData = {
  env: appEnv,
  appName: 'hellobike',
  systemCode: 63,
  version: appVersion,
};

let galileoAb:any;

const { UBT } = (window as any).TianQi;

// 初始化
if (UBT && !isPrerendering()) {
  /** 骚操作，为了解决伽利略报错问题 */
  if (!UBT.baseParams) {
    UBT.baseParams = {};
  }

  try {
    galileoAb = new GalileoAb(
      { ...bindData },
      UBT,
    );
  } catch {
    // do nothing
  }
}

type GetAbResFunction = (
  /** 实验id */
  experimentId: string,
  /** 默认兜底实验 id ：一般是填对照组 */
  defaultVersionId: string
) => Promise<AbTestArgs>;

/** 读取userGuid，如ProxyUbtForRisk同步代码执行时，此时store不一定有值 */
export const getUserGuid = (): string => store?.state?.base?.originUserInfo.userGuid || '';

export const getGalileoAb = ():{
    getAbRes: GetAbResFunction,
    getAbResCatchError: GetAbResFunction
} => {
  const getAbRes = (experimentId:string, defaultVersionId:string):
  Promise<AbTestArgs> => new Promise(
    (resolve:PromiseResolve<AbTestArgs>) => {
      if (galileoAb) {
        // 获取单个实验结果(sdk内部对分流接口异常，会封装返回resolve)
        galileoAb.getAbSingleResult({
          experimentId, // 实验ID
          defaultVersionId, // 兜底版本
          userGuid: getUserGuid(),
          timeout: 1000,
        }).then((res:any) => {
          const { versionArgs } = res as {versionArgs: AbTestArgs} || {};
          resolve(versionArgs);
        });
      } else {
        resolve({});
      }
    },
  );

  /**
   * 扩展getGalileoAb方法，此方法内部try catch
   * 服务于逻辑需要依赖ab实验结果，但ab实验异常报错不能影响后续逻辑执行
   * 使用者可选择性使用getGalileoAb/getAbResCatchError方法
   */
  const getAbResCatchError = (experimentId:string, defaultVersionId:string):
  Promise<AbTestArgs> => new Promise(
    async (resolve:PromiseResolve<AbTestArgs>) => {
      try {
        const res = await getGalileoAb().getAbRes(experimentId, defaultVersionId) || {};
        resolve(res);
      } catch (err) {
        ubtSendError(err as Error);
        resolve({});
      }
    },
  );
  return {
    getAbRes,
    getAbResCatchError,
  };
};
